export default __webpack_public_path__ + "static/media/step-end-active.e723829d.png";